<!-- Overlay -->
@if (isOpen()) {
  <div class="fixed inset-0 z-40 bg-black/50" (click)="onCloseModal()"></div>

  <!-- Modal -->
  <div
    class="fixed top-1/2 left-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 transform rounded-lg bg-white p-6 shadow-lg">
    <!-- Header -->
    <div class="relative flex items-center justify-between">
      <h3 class="text-primary text-lg font-semibold" i18n="@@adminAddUserSuccessTitle">User Created Successfully</h3>
      <button
        type="button"
        class="border-primary cursor-pointer rounded border p-1 text-gray-500 hover:text-gray-700 focus:outline-none"
        aria-label="Close"
        (click)="onCloseModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
          <path
            class="stroke-primary fill-primary"
            d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59L7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12L5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
            stroke-width="0.5" />
        </svg>
      </button>
    </div>

    <!-- Message -->
    <p class="mt-4 text-sm text-gray-700" i18n="@@adminAddUserSuccessDescription">
      The user
      <span class="font-semibold">{{ createdUser().firstName + " " + createdUser().lastName }}</span>
      has been created successfully
    </p>

    <!-- User Info -->
    <div class="mt-4 grid grid-cols-1 gap-4 pt-4">
      <div>
        <p class="text-sm font-medium text-gray-500" i18n="@@adminAddUserSuccessUsernameLabel">Username</p>
        <p class="createUserUsername my-2 rounded bg-gray-100 p-2 text-sm text-gray-800">
          {{ createdUser().username }}
        </p>
      </div>
      <div>
        <p class="text-sm font-medium text-gray-500" i18n="@@adminAddUserSuccessPasswordLabel">Password</p>

        <div class="relative my-2 flex items-center justify-between gap-2 rounded bg-gray-100 p-2">
          @if (!showPassword()) {
            <p class="text-sm text-gray-800">{{ "*".repeat(createdUser().password.length) }}</p>
          } @else {
            <p class="text-sm text-gray-800">{{ createdUser().password }}</p>
          }

          <button (click)="togglePasswordVisibility()" type="button" class="mt-1 text-sm">
            @if (!showPassword()) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.25em"
                height="1.25em"
                viewBox="0 0 24 24"
                class="cursor-pointer">
                <path
                  class="fill-black-solid stroke-black-solid"
                  d="M12 9.005a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 1.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5M12 5.5c4.613 0 8.596 3.15 9.701 7.564a.75.75 0 1 1-1.455.365a8.504 8.504 0 0 0-16.493.004a.75.75 0 0 1-1.456-.363A10 10 0 0 1 12 5.5"
                  stroke-width="0.5" />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1.25em"
                height="1.25em"
                viewBox="0 0 16 16"
                class="cursor-pointer">
                <path
                  class="fill-black-solid stroke-black-solid"
                  d="m10.12 10.827l4.026 4.027a.5.5 0 0 0 .708-.708l-13-13a.5.5 0 1 0-.708.708l3.23 3.23A6 6 0 0 0 3.2 6.182a6.7 6.7 0 0 0-1.117 1.982c-.021.061-.047.145-.047.145l-.018.062s-.076.497.355.611a.5.5 0 0 0 .611-.355l.001-.003l.008-.025l.035-.109a5.7 5.7 0 0 1 .945-1.674a5 5 0 0 1 1.124-1.014L6.675 7.38a2.5 2.5 0 1 0 3.446 3.446m-.74-.74A1.5 1.5 0 1 1 7.413 8.12zM6.32 4.2l.854.854Q7.564 5 8 5c2.044 0 3.286.912 4.028 1.817a5.7 5.7 0 0 1 .945 1.674q.025.073.035.109l.008.025v.003l.001.001a.5.5 0 0 0 .966-.257v-.003l-.001-.004l-.004-.013a2 2 0 0 0-.06-.187a6.7 6.7 0 0 0-1.117-1.982C11.905 5.089 10.396 4 8.002 4c-.618 0-1.177.072-1.681.199"
                  stroke-width="0.5" />
              </svg>
            }
          </button>
        </div>
      </div>
    </div>

    <div class="mt-4 flex justify-end gap-2">
      <button
        type="button"
        class="bg-primary hover-bg-primary-hover flex cursor-pointer items-center gap-2 rounded px-4 py-1 text-sm font-medium text-white"
        (click)="onCopyCredentials()">
        <span i18n="@@adminAddUserSuccessCopyButtonLabel" class="text-white">Copy</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
          <g class="stroke-bg-white" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <path
              d="M7 9.667A2.667 2.667 0 0 1 9.667 7h8.666A2.667 2.667 0 0 1 21 9.667v8.666A2.667 2.667 0 0 1 18.333 21H9.667A2.667 2.667 0 0 1 7 18.333z" />
            <path d="M4.012 16.737A2 2 0 0 1 3 15V5c0-1.1.9-2 2-2h10c.75 0 1.158.385 1.5 1" />
          </g>
        </svg>
      </button>
      <button
        (click)="onCloseModal()"
        i18n="@@adminAddUserSuccessOkButtonLabel"
        class="border-primary text-primary flex cursor-pointer items-center gap-2 rounded border-2 bg-transparent px-4 py-1 text-sm font-medium hover:bg-gray-200">
        OK
      </button>
    </div>
  </div>
}

@if (isNotification()) {
  <app-successful-notification
    [type]="'success'"
    title="Registration Successful"
    i18n-title="@@adminAddUserSuccessNotificationLabel" />
}
